/**
 * Reference documentation
 * https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media
 * https://developers.facebook.com/docs/messenger-platform/reference/send-api
 * https://developers.facebook.com/docs/messenger-platform/instagram/features/send-message
 */

// Common MIME types
const FB_VIDEO_TYPES = ['video/mpeg4', 'video/mp4', 'video/wav', 'video/m4a'];
const IMAGE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
const WS_VIDEO_TYPES = FB_VIDEO_TYPES.concat(['video/quicktime', 'video/avi', 'video/webm']);
const AUDIO_TYPES = ['audio/mpeg'];
const DOCUMENT_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel'
];

// eslint-disable-next-line import/prefer-default-export
export const MEDIA_LIMITS = {
  whatsapp: {
    image: { maxMB: 5, types: IMAGE_TYPES },
    video: { maxMB: 16, types: WS_VIDEO_TYPES },
    audio: { maxMB: 40, types: AUDIO_TYPES },
    document: { maxMB: 40, types: DOCUMENT_TYPES }
  },

  messenger: {
    image: { maxMB: 15, types: IMAGE_TYPES },
    video: { maxMB: 16, types: FB_VIDEO_TYPES },
    audio: { maxMB: 25, types: AUDIO_TYPES },
    document: { maxMB: 25, types: DOCUMENT_TYPES }
  },

  instagram: {
    image: { maxMB: 15, types: IMAGE_TYPES },
    video: { maxMB: 16, types: FB_VIDEO_TYPES },
    audio: { maxMB: 25, types: AUDIO_TYPES }
  }
};
